import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import moment from "moment";

const ReactCountUp = ({ dateAndTime }) => {
  const [timeDiff, setTimeDiff] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentTime = moment();
      const lastAssigned = moment(dateAndTime, "YYYY-MM-DD HH:mm");
      const diff = moment.duration(currentTime.diff(lastAssigned));

      setTimeDiff({
        days: Math.floor(diff.asDays()),
        hours: diff.hours(),
        minutes: diff.minutes(),
        seconds: diff.seconds(),
        milliseconds: diff.milliseconds(),
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [dateAndTime]);

  return (
    <div className="counter-up-clock-container">
      <CountUp start={0} end={timeDiff.days} duration={1} suffix=" days" />
      <CountUp start={0} end={timeDiff.hours} duration={1} suffix=" hours" />
      <CountUp
        start={0}
        end={timeDiff.minutes}
        duration={1}
        suffix=" minutes"
      />
      {/* <CountUp
        start={0}
        end={timeDiff.seconds}
        duration={1}
        suffix=" seconds"
      /> */}
    </div>
  );
};

export default ReactCountUp;
